var map = {
	"./amadeus/MasterDetail.json": 1170,
	"./barclays/MasterDetail.json": 1171,
	"./cb911/MasterDetail.json": 1172,
	"./choiceHotels/MasterDetail.json": 1173,
	"./globex/MasterDetail.json": 1174,
	"./kraken/MasterDetail.json": 1175,
	"./lastminute/MasterDetail.json": 1176,
	"./monavate/MasterDetail.json": 1177,
	"./outpayce/MasterDetail.json": 1178,
	"./sofi/MasterDetail.json": 1179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1169;